var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { RendererFactory } from "survey-core";
import { attachKey2click, ReactQuestionFactory, SurveyElementBase, SurveyQuestionElementBase } from "survey-react-ui";
var SurveyQuestionBooleanSwitch = /** @class */ (function (_super) {
    __extends(SurveyQuestionBooleanSwitch, _super);
    function SurveyQuestionBooleanSwitch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurveyQuestionBooleanSwitch.prototype.renderElement = function () {
        var _this = this;
        var button = attachKey2click(React.createElement("div", { className: "spg-boolean-switch__button" + (this.questionBase.value ? " spg-boolean-switch__button--checked" : ""), tabIndex: 0, role: "checkbox", "aria-checked": this.questionBase.booleanValue || false, "aria-required": this.questionBase.a11y_input_ariaRequired, "aria-label": this.questionBase.a11y_input_ariaLabel, "aria-labelledby": this.questionBase.a11y_input_ariaLabelledBy, "aria-invalid": this.questionBase.a11y_input_ariaInvalid, "aria-errormessage": this.questionBase.a11y_input_ariaErrormessage },
            React.createElement("div", { className: "spg-boolean-switch__thumb" },
                React.createElement("div", { className: "spg-boolean-switch__thumb-circle spg-boolean-switch__thumb--left" })),
            React.createElement("div", { className: "spg-boolean-switch__thumb" },
                React.createElement("div", { className: "spg-boolean-switch__thumb-circle spg-boolean-switch__thumb--right" }))), this.questionBase, { processEsc: false });
        return (React.createElement("div", { className: "spg-boolean-switch", onClick: function () { return _this.questionBase.value = !_this.questionBase.value; } },
            button,
            React.createElement("div", { className: "spg-boolean-switch__caption" },
                React.createElement("div", { className: "spg-boolean-switch__title", id: this.questionBase.labelRenderedAriaID }, SurveyElementBase.renderLocString(this.questionBase.locTitle)))));
    };
    return SurveyQuestionBooleanSwitch;
}(SurveyQuestionElementBase));
export { SurveyQuestionBooleanSwitch };
ReactQuestionFactory.Instance.registerQuestion("sv-boolean-switch", function (props) {
    return React.createElement(SurveyQuestionBooleanSwitch, props);
});
RendererFactory.Instance.registerRenderer("boolean", "switch", "sv-boolean-switch");
